<template>
  <v-main>
    <!-- / Mini Variant Sidebar -->
    <v-container fluid>
      <div class="dj-page-head">
        <div class="dj-page-head__text dj-page-head__row">
          <backbutton></backbutton>
          <h1 class="dj-page-title">{{ capitalize(type) }}</h1>
          <span class="dj-page-index" v-if="!isLoading && !loadError">
            {{ projects.length }} {{ projects.length === 1 ? "record" : "records" }}
          </span>
        </div>
        <div class="dj-page-actions">
          <v-btn
            fab
            small
            depressed
            color="primary"
            :to="`/${type.toLowerCase()}s/create?type=${type}`"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
          <v-btn
            v-if="type == 'QUOTATION' || type == 'TEMPLATE'"
            fab
            small
            depressed
            color="primary"
            :to="`/${type.toLowerCase()}s/upload?type=${type}`"
          >
            <v-icon dark> mdi-upload </v-icon>
          </v-btn>
        </div>
      </div>
      <v-row>
        <v-col md="6">
          <v-text-field
            v-model="search_keyword"
            label="Search ... "
            prepend-inner-icon="mdi-magnify"
            @keydown.enter="getData()"
            @change="page = 1"
          ></v-text-field>
        </v-col>
        <v-col sm="4" v-if="roleName == 'Handler' && type == 'PROJECT'">
          <v-switch
            v-model="isOtherProjects"
            inset
            @change="getData()"
            :label="`See Other's Projects: ${
              isOtherProjects == true ? 'YES' : 'NO'
            }`"
          ></v-switch>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-alert
        v-if="!isLoading && loadError"
        type="error"
        border="left"
        dense
        class="my-3"
      >
        {{ loadError }}
      </v-alert>
      <v-row v-else-if="!isLoading">
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Status</th>
                    <th
                      class="text-left"
                      v-if="type == 'PROJECT' || type == 'QUOTATION'"
                    >
                      Documents
                    </th>
                    <th class="text-left" v-if="type == 'PROJECT'">Logo</th>
                    <th class="text-left" v-if="type == 'PROJECT'">
                      Feedback Rating
                    </th>
                    <th class="text-left" v-if="type == 'PROJECT'">Port</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(project, i) in projects" :key="project.id">
                    <td>{{ i + 1 }}</td>
                    <td>{{ project.name }}</td>
                    <td>{{ project.status ? "ACTIVE" : "INACTIVE" }}</td>
                    <td
                      style="width: 250px"
                      v-if="type == 'PROJECT' || type == 'QUOTATION'"
                    >
                      <v-expansion-panels class="my-2">
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            List of Documents
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-simple-table fixed-header>
                              <template v-slot:default>
                                <tbody>
                                  <tr
                                    v-for="(
                                      document, d
                                    ) in project.project_documents"
                                    :key="`document${d}`"
                                  >
                                    <td>
                                      <v-btn
                                        rounded
                                        color="primary"
                                        target="_blank"
                                        :href="`${
                                          mediaUrl + document.documentpath
                                        }`"
                                        ><v-icon>mdi-file</v-icon>
                                        {{ document.documentpath | filename }}
                                      </v-btn>
                                    </td>
                                    <td>
                                      <!-- Delete Button -->
                                      <v-tooltip bottom>
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            color="primary"
                                            icon
                                            @click="
                                              delete_data(
                                                document.id,
                                                'project_documents'
                                              )
                                            "
                                          >
                                            <v-icon>mdi-delete-outline</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Delete Document</span>
                                      </v-tooltip>
                                      <!-- End Delete Button -->
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </td>
                    <td v-if="type == 'PROJECT'">
                      <v-btn
                        v-if="project.logo"
                        rounded
                        color="primary"
                        target="_blank"
                        :href="`${mediaUrl + project.logo}`"
                        ><v-icon>mdi-file</v-icon>
                        {{ project.logo | filename }}
                      </v-btn>
                    </td>
                    <td v-if="type == 'PROJECT'">
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mx-2"
                            color="primary"
                            icon
                            @click="showFeedback(project)"
                          >
                            {{
                              project.avg_feedback_rating
                                ? project.avg_feedback_rating.toFixed(2)
                                : 0
                            }}
                          </v-btn>
                        </template>
                        <span>Feedback</span>
                      </v-tooltip>
                    </td>
                    <td v-if="type == 'PROJECT'">
                      {{ project.port ? project.port.description : "" }}
                    </td>
                    <td class="text-right dj-actions">
                      <!-- Download Excel -->
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            icon
                            @click="generateExcel(project)"
                            color="success"
                            :loading="project.isProjectExcelLoading"
                            :disabled="project.isProjectExcelLoading"
                          >
                            <download-excel
                              :title="title"
                              :data="report_excel"
                              :fields="excel_fields"
                              worksheet="Project Report"
                              name="Project-Report.xls"
                            >
                              <v-icon>mdi-microsoft-excel</v-icon>
                            </download-excel>
                          </v-btn>
                        </template>
                        <span>Download Excel </span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            icon
                            @click="getPDFData(project.id)"
                            color="secondary"
                            :loading="isPDFLoading"
                            :disabled="isPDFLoading"
                          >
                            <download-excel
                              :title="title"
                              :data="report_excel"
                              :fields="excel_fields"
                              worksheet="Project Report"
                              name="Project-Report.xls"
                            >
                              <v-icon>mdi-file-pdf-box</v-icon>
                            </download-excel>
                          </v-btn>
                        </template>
                        <span>Download PDF </span>
                      </v-tooltip>
                      <!-- End For Download Excel -->
                      <!-- View Modules Button -->
                      <v-tooltip left v-if="type != 'TEMPLATE'">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="secondary"
                            icon
                            :to="`/modules/tree?type=VESSEL&project_id=${project.id}`"
                          >
                            <v-icon>mdi-ferry</v-icon>
                          </v-btn>
                        </template>
                        <span>View VESSEL Modules</span>
                      </v-tooltip>
                      <!-- End View Modules Button -->
                      <!-- View Modules Button -->
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="secondary"
                            icon
                            :to="`/modules/tree?type=GENERAL&project_id=${project.id}`"
                          >
                            <v-icon>mdi-account-wrench</v-icon>
                          </v-btn>
                        </template>
                        <span>View GENERAL Modules</span>
                      </v-tooltip>
                      <!-- End View Modules Button -->
                      <!-- Delete Button -->
                      <v-tooltip
                        bottom
                        v-if="
                          roleName != 'Handler' ||
                          (project.created_by_id == user.id &&
                            roleName == 'Handler')
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="error"
                            icon
                            @click="delete_data(project.id, 'projects')"
                          >
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete {{ type | capitalize }}</span>
                      </v-tooltip>
                      <!-- End Delete Button -->
                      <!-- Edit Button -->
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="ml-1 dj-actions__edit"
                            fab
                            depressed
                            v-bind="attrs"
                            v-on="on"
                            x-small
                            color="primary"
                            :to="`/${project.type.toLowerCase()}s/${
                              project.id
                            }`"
                          >
                            <v-icon dark small> mdi-pencil </v-icon>
                          </v-btn>
                        </template>
                        <span>Edit {{ type | capitalize }} Details</span>
                      </v-tooltip>
                      <!-- End Edit Button -->
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
        <!-- Module Job Feedback Pop UP  -->
        <v-dialog v-model="show_module_job_feedback" max-width="1230px">
          <v-card elevation="2">
            <v-card-title>
              <span>
                <h2>Feedback Ratings</h2>
              </span>
              <v-spacer></v-spacer>
              <v-btn icon @click="show_module_job_feedback = false">
                <v-icon>mdi-window-close </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="mt-5">
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Job Name</th>
                      <th class="text-left">Cleaniness</th>
                      <th class="text-left">Organised</th>
                      <th class="text-left">Quality of Work</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(job, i) in jobs" :key="job.id">
                      <td>{{ i + 1 }}</td>
                      <td>{{ job.name }}</td>
                      <td>{{ job.cleaniness ? job.cleaniness : 0 }}</td>
                      <td>{{ job.organised ? job.organised : 0 }}</td>
                      <td>
                        {{
                          job.quality_of_workRating
                            ? job.quality_of_workRating
                            : 0
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- / Module Job Feedback Pop UP -->
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import backbutton from "@/components/backbutton.vue";
import moment from "moment";
export default {
  components: { backbutton },
  name: "ProjectsPage",
  data() {
    return {
      isOtherProjects: false,
      show_module_job_feedback: false,
      projects: [],
      project_details: [],
      userProjects: [],
      otherProjects: [],
      vessels: [],
      geberals: [],
      jobs: [],
      search_keyword: "",
      isLoading: false,
      loadError: "",
      isProjectExcelLoading: false,
      isPDFLoading: false,
      type: "PROJECT",
      excel_fields: {
        "Sr No": "sr_no",
        "Job Details": "module_name",
        Status: "status",
        "Workshop Names": "workshop_name",
      },
      report_excel: [],
      title: "Project Report",
    };
  },
  watch: {
    $route() {
      this.type = this.$route.query.type ? this.$route.query.type : "PROJECT";
      this.getData();
    },
  },
  mounted() {
    this.type = this.$route.query.type ? this.$route.query.type : "PROJECT";
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.loadError = "";
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let query =
        "search_keyword=" + this.search_keyword + "&type=" + this.type;
      try {
        const projects = await axios.get(`projects?${query}`);
        this.projects = (projects.data && projects.data.data) || [];
        let userProjects = this.projects.filter(
          (project) => project.created_by_id == this.user.id
        );
        this.userProjects = userProjects;
        let otherProjects = this.projects.filter(
          (project) => project.created_by_id != this.user.id
        );
        this.otherProjects = otherProjects;
        if (this.roleName == "Handler") {
          this.projects = this.userProjects;
        }
        if (this.isOtherProjects == true) {
          this.projects = this.otherProjects;
        }
      } catch (e) {
        const status = e.response ? e.response.status : "no response (network/CORS)";
        const body =
          e.response && e.response.data
            ? typeof e.response.data === "string"
              ? e.response.data.slice(0, 300)
              : JSON.stringify(e.response.data).slice(0, 300)
            : e.message;
        this.loadError = `Failed to load projects — HTTP ${status}. ${body}`;
        // eslint-disable-next-line no-console
        console.error("getData(projects) failed:", status, e.response || e);
      } finally {
        this.isLoading = false;
      }
    },
    async delete_data(id, table) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=${table}`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
    capitalize(string) {
      if (string) {
        let capitalized_string =
          string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        return capitalized_string;
      }
    },
    async generateExcel(project_details) {
      project_details.isProjectExcelLoading = true;
      let response = await axios.get(
        `projects/export?project_id=${project_details.id}&project_type=${project_details.type}`
      );
      if (response) {
        window.open(
          `${response.data.data}`,
          "_blank" // <- This is what makes it open in a new window.
        );
      }
      project_details.isProjectExcelLoading = false;
    },
    getProjectTimeline(project) {
      let project_total_date_array = [];
      project.modules.forEach((module) => {
        if (module.type == "VESSEL") {
          this.showModuleTimeline(module);
          project_total_date_array = project_total_date_array.concat(
            module.total_range
          );
        }
      });
      project_total_date_array = [
        ...new Set(
          project_total_date_array.sort((a, b) => {
            if (a["date"] < b["date"]) return -1;
            if (a["date"] > b["date"]) return 1;
            return 0;
          })
        ),
      ];
      console.log(project_total_date_array);

      let p_fromDate = moment(project_total_date_array[0].date);
      let p_toDate = moment(
        project_total_date_array[project_total_date_array.length - 1].date
      );
      let project_total_daterange = [];
      while (p_fromDate <= p_toDate) {
        let ld = p_fromDate.format("YYYY-MM-DD");
        let date = {
          date: ld,
        };
        project_total_daterange.push(date);
        p_fromDate = moment(p_fromDate).add(1, "days");
      }
      project.total_daterange = project_total_daterange;
      console.log(project.total_daterange);
    },
    showModuleTimeline(module) {
      this.show_module_details = true;
      if (module) {
        // If Module
        let total_array = [];
        module.module_jobs.forEach((moduleJob) => {
          let fromDate = "";
          let toDate = "";

          // Make a Blank array of Estimate Start & End Date

          let array = [
            moduleJob.estimate_start_date,
            moduleJob.estimate_end_date,
          ];

          if (moduleJob.actual_start_date) {
            // If Actual star Date added
            array.push(moduleJob.actual_start_date);
          }
          if (moduleJob.actual_end_date) {
            array.push(moduleJob.actual_end_date);
          }
          array.sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          });
          fromDate = moment(array[0]);
          toDate = moment(array[array.length - 1]);

          let dateRange = [];
          if (fromDate && toDate) {
            while (fromDate <= toDate) {
              let ld = fromDate.format("YYYY-MM-DD");
              let date = {
                date: ld,
              };
              dateRange.push(date);
              fromDate = moment(fromDate).add(1, "days");
            }
          }

          let estimate_date_range = [];
          let estimate_start_date = moment(moduleJob.estimate_start_date);
          let estimate_end_date = moment(moduleJob.estimate_end_date);
          while (estimate_start_date <= estimate_end_date) {
            let ld = estimate_start_date.format("YYYY-MM-DD");
            estimate_date_range.push(ld);
            estimate_start_date = moment(estimate_start_date).add(1, "days");
          }

          let actual_start_date = moment(moduleJob.actual_start_date);
          let actual_end_date = moment(moduleJob.actual_end_date);

          let actual_date_range = [];
          while (actual_start_date <= actual_end_date) {
            let ld = actual_start_date.format("YYYY-MM-DD");
            actual_date_range.push(ld);
            actual_start_date = moment(actual_start_date).add(1, "days");
          }

          dateRange.forEach((date) => {
            date.actual_exists = actual_date_range.some(function (actual_date) {
              return actual_date === date.date;
            });
            date.estimate_exists = estimate_date_range.some(function (
              estimate_date
            ) {
              return estimate_date === date.date;
            });

            if (
              date.estimate_exists == true &&
              moduleJob.actual_start_date == null
            ) {
              date.color = "yellow";
            } else if (
              date.estimate_exists == true &&
              date.actual_exists == false
            ) {
              date.color = "orange";
            } else if (
              date.estimate_exists == true &&
              date.actual_exists == true
            ) {
              date.color = "green";
            } else if (
              date.estimate_exists == false &&
              date.actual_exists == true
            ) {
              date.color = "red";
            } else {
              date.color = "white";
            }
          });
          moduleJob.dateRange = dateRange;
          total_array = total_array.concat(array);
        });
        total_array = [
          ...new Set(
            total_array.sort((a, b) => {
              if (a < b) return -1;
              if (a > b) return 1;
              return 0;
            })
          ),
        ];
        let t_fromDate = moment(total_array[0]);
        let t_toDate = moment(total_array[total_array.length - 1]);
        let total_range = [];
        while (t_fromDate <= t_toDate) {
          let ld = t_fromDate.format("YYYY-MM-DD");
          let date = {
            date: ld,
          };
          total_range.push(date);
          t_fromDate = moment(t_fromDate).add(1, "days");
        }
        module.total_range = total_range;
      }
    },
    showModuleJobTimeline(moduleJob) {
      this.moduleJob = {};
      this.show_module_job = true;
      if (moduleJob) {
        // If Module Job
        this.moduleJob = moduleJob;
        // Make a Blank array of Estimate Start & End Date
        let array = [
          this.moduleJob.estimate_start_date,
          this.moduleJob.estimate_end_date,
        ];

        if (this.moduleJob.actual_start_date) {
          // If Actual star Date added
          array.push(this.moduleJob.actual_start_date);
        }
        if (this.moduleJob.actual_end_date) {
          array.push(this.moduleJob.actual_end_date);
        }
        array.sort((a, b) => {
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        });
        let fromDate = moment(array[0]);
        let toDate = moment(array[array.length - 1]);

        let dateRange = [];
        while (fromDate <= toDate) {
          let ld = fromDate.format("YYYY-MM-DD");
          let date = {
            date: ld,
          };
          dateRange.push(date);
          fromDate = moment(fromDate).add(1, "days");
        }

        let estimate_date_range = [];
        let estimate_start_date = moment(this.moduleJob.estimate_start_date);
        let estimate_end_date = moment(this.moduleJob.estimate_end_date);
        while (estimate_start_date <= estimate_end_date) {
          let ld = estimate_start_date.format("YYYY-MM-DD");
          estimate_date_range.push(ld);
          estimate_start_date = moment(estimate_start_date).add(1, "days");
        }

        let actual_start_date = moment(this.moduleJob.actual_start_date);
        let actual_end_date = moment(this.moduleJob.actual_end_date);

        let actual_date_range = [];
        while (actual_start_date <= actual_end_date) {
          let ld = actual_start_date.format("YYYY-MM-DD");
          actual_date_range.push(ld);
          actual_start_date = moment(actual_start_date).add(1, "days");
        }

        dateRange.forEach((date) => {
          date.actual_exists = actual_date_range.some(function (actual_date) {
            return actual_date === date.date;
          });
          date.estimate_exists = estimate_date_range.some(function (
            estimate_date
          ) {
            return estimate_date === date.date;
          });

          if (
            date.estimate_exists == true &&
            moduleJob.actual_start_date == null
          ) {
            date.color = "yellow";
          } else if (
            date.estimate_exists == true &&
            date.actual_exists == false
          ) {
            date.color = "orange";
          } else if (
            date.estimate_exists == true &&
            date.actual_exists == true
          ) {
            date.color = "green";
          } else if (
            date.estimate_exists == false &&
            date.actual_exists == true
          ) {
            date.color = "red";
          } else {
            date.color = "";
          }
        });
        this.moduleJob.dateRange = dateRange;
      }
    },
    showFeedback(project) {
      this.show_module_job_feedback = true;
      this.jobs = [];
      project.modules.forEach((module) => {
        module.module_jobs.forEach((job) => {
          job.module_job_feedbacks.forEach((feedback) => {
            switch (feedback.category) {
              case "Cleaniness":
                job["cleaniness"] = feedback.rating;
              case "Organised":
                job["organised"] = feedback.rating;
              case "Quality of Work":
                job["quality_of_workRating"] = feedback.rating;
                break;

              default:
                break;
            }
          });
          this.jobs.push(job);
        });
      });
    },
    async getPDFData(project_id) {
      this.isPDFLoading = true;
      let query = "project_id=" + project_id;
      let response = await axios.get(`projects/pdf?${query}`);
      if (response) {
        window.open(
          `${response.data.data}`,
          "_blank" // <- This is what makes it open in a new window.
        );
      }
      // this.vessels = vessels.data.projects;
      // this.generals = vessels.data.generals;
      console.log(this.vessels);
      this.isPDFLoading = false;
    },
  },
};
</script>

<style scoped>
/* Row action cluster: consistent sizing, calm ghost icons, one brass accent */
.dj-actions {
  white-space: nowrap;
  vertical-align: middle;
}
.dj-actions ::v-deep .v-btn--icon {
  margin: 0 1px;
}
.dj-actions ::v-deep .v-btn--icon:hover {
  background: var(--dj-panel);
}
.dj-actions__edit {
  box-shadow: 0 3px 10px -3px var(--dj-accent-ring) !important;
}
.dj-actions__edit:hover {
  box-shadow: 0 5px 14px -3px var(--dj-accent-ring) !important;
}
</style>
